import { useState, useMemo } from 'react'
import { useRouter } from 'next/router'

import { getParams } from 'utils/getURLData'
import { IOptionAliases } from 'constants/types/search.types'

const useSearchSelectedOption = (OptionAliases: IOptionAliases) => {
  const router = useRouter()
  const params = useMemo(() => getParams(router.asPath), [])
  const foundOption = OptionAliases.find(
    (option) => option.option === params.type || option.alias === params.type
  )
  const initOption = foundOption ? foundOption.option : OptionAliases[0].option
  const [selectedOption, setSelectedOption] = useState(initOption)

  return { selectedOption, setSelectedOption }
}

export default useSearchSelectedOption
